import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export async function copyText(t) {
  try { await navigator.clipboard.writeText(t); return true; } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = t; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}

export function CopyButton({ text, k, kit, testid, label, disabled }) {
  const done = kit.copied.has(k);
  const go = async () => {
    if (await copyText(text)) { kit.mark(k); toast.success("Copied", { duration: 900 }); }
    else toast.error("Your browser blocked copying");
  };
  return (
    <button data-testid={testid} disabled={disabled || !text} onClick={go}
      className={`shrink-0 inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-md border transition-colors disabled:opacity-30 disabled:pointer-events-none ${done ? "border-emerald-500/40 text-emerald-300 bg-emerald-500/10" : "border-border text-slate-300 hover:border-blue-500/60 hover:text-white hover:bg-blue-500/10"}`}>
      {done ? <Check size={13} /> : <Copy size={13} />}{label || (done ? "Copied" : "Copy")}
    </button>
  );
}

export function Field({ label, value, k, kit, testid }) {
  return (
    <div className="flex items-start gap-3 py-2 border-b border-border/60 last:border-0" data-testid={`${testid}-row`}>
      <div className="w-32 shrink-0 label-xs pt-1">{label}</div>
      <div className={`flex-1 text-sm min-w-0 break-words ${value ? "text-slate-100" : "text-slate-600"}`} data-testid={`${testid}-value`}>{value || "Not on resume"}</div>
      <CopyButton text={value} k={k} kit={kit} testid={`${testid}-copy`} />
    </div>
  );
}

export function Section({ title, hint, action, children, testid }) {
  return (
    <section className="card-surface" data-testid={testid}>
      <div className="flex items-center gap-3 mb-2">
        <div><div className="font-semibold font-display">{title}</div>{hint && <div className="text-xs text-muted-foreground">{hint}</div>}</div>
        <div className="ml-auto flex gap-2">{action}</div>
      </div>
      {children}
    </section>
  );
}
